<template>
    <section>
        <div v-if="loading">

            <!-- List -->
            <div class="overflow-auto">
                
                <div class="flex justify-between my-2">
                    <div class="flex text-center">
                        <div class="font-bold bg-theme-1 text-white text-bold rounded text-md mx-auto w-76 p-2">{{ start_date }} a {{ end_date }}</div>
                    </div>
                    <router-link
                    :to="'/admin/reports'"
                    class="w-50"
                    >
                    <button
                        class="button button--sm w-32 flex items-center justify-center bg-theme-1 text-white zoom-in"
                    >
                        <app-icon :name="'chart'" :classname="'w-4 h-4 mr-2'" />
                        Reporte
                    </button>
                    </router-link>
                </div>
                <div class="flex">
                    <div class="flex w-1/2">
                        <div class="w-2/4 flex gap-2">
                            <p class="py-2 pt-2 w-20">Ordenar por:</p>
                            <select
                            class="input w-full border flex-1"
                            @change="changeOrder($event)"
                            v-model="order_select"
                            required
                            >
                            <template v-for="item in orders">
                                <option :value="item.id">
                                {{ item.name }}
                                </option>
                            </template>
                            </select>
                        </div>
                    </div>
                    <div class="flex w-1/2" v-if="[1,2,3,9].includes(user.team_id)">
                        <div class="w-2/4 flex gap-2">
                            <div class="py-2 pt-2 w-20">Filtrar por:</div>
                            <select
                            class="input w-full border flex-1"
                            @change="changeGroup($event)"
                            v-model="filter.group"
                            required
                            >
                                <option disabled selected>Seleccione la cuenta</option>
                                <option
                                    v-for="group in groups"
                                    v-bind:key="group.id"
                                    v-bind:value="group.id"
                                >
                                    {{ group.name }}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
                
                <div class="flex py-4 gap-2">
                    <div class="w-1/3 text-center bg-white shadow-lg p-2 rounded-lg">
                        Total Horas: <b>{{ total_hours }}</b>
                    </div>
                    <div class="w-1/3 text-center bg-white shadow-lg p-2 rounded-lg">
                        Total Horas Usadas: <b>{{ total_hours_used.toFixed(2) }}</b>
                    </div>
                    <div class="w-1/3 text-center bg-white shadow-lg p-2 rounded-lg">
                        Horas Disponibles: <b>{{ parseFloat(total_hours - total_hours_used).toFixed(2) }}</b>
                    </div>
                </div>

                <table class="table table-report -mt-2">
                    <thead>
                        <tr>
                            <th class="whitespace-no-wrap">CUENTA - PROYECTO</th>
                            <th class="text-center whitespace-no-wrap">GRUPO</th>
                            <th class="text-center whitespace-no-wrap">HORAS</th>
                            <th class="text-center whitespace-no-wrap">USADAS</th>
                            <th class="text-center whitespace-no-wrap">PORCENTAJE</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="intro-x" v-for="task in tasks">
                            <td>
                                <div class="font-medium whitespace-no-wrap">
                                    <b :class="[
                                        task.hours > 1
                                            ? 'text-theme-1'
                                            : '',
                                    ]">{{ task.name }}</b>
                                </div>
                            </td>
                            <td>
                                <div class="text-center text-gray-600 text-xs whitespace-no-wrap">{{ task.group }}</div>
                            </td>
                            <td>
                                <div class="text-center text-gray-600 text-xs whitespace-no-wrap">{{ task.hours }}</div>
                            </td>
                            <td>
                                <div class="text-center text-gray-600 text-xs whitespace-no-wrap">{{ task.hours_used }}</div>
                            </td>
                            <td>
                                <div class="w-full h-4 bg-gray-400 rounded">
                                    <div class="h-full rounded text-center text-xs text-white bg-theme-6" v-if="task.percentage > 100"
                                        :style="{ width: '100%' }">{{ task.percentage }}%</div>
                                    <div class="h-full rounded text-center text-xs text-white bg-theme-1" v-else
                                        :style="{ width: task.percentage > 0 ? task.percentage + '%' : '0px' }">{{ task.percentage }}%</div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <!-- END: List -->

        </div>

        <app-loading v-else />

    </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Loading from '@/components/admin/partials/LoadingWhite'
import Icon from '@/components/admin/partials/Icon'

export default {
    name: 'AdminTaskHoursMonth',
    data() {
        return {
            loading: false,
            tasks: [],
            groups: [],
            team_session: null,
            account_session: null,
            start_date: null,
            end_date: null,
            order_select: 'percentage',
            orders: [
                { 'id' : 'percentage' , 'name' : 'Porcentaje' },
                { 'id' : 'hours' , 'name' : 'Horas' },
                { 'id' : 'hours_used', 'name': 'Horas Usadas' },
            ],
            filter:{
                group: null
            },
            total_hours : 0,
            total_hours_used : 0
        }
    },
    computed: {
    ...mapGetters({
        user: 'getUser'
        })
    },
    async beforeMount() {
        this.account_session = localStorage.session_account
        this.team_session = localStorage.session_team
        try {
            await this.getTasks()
        } catch (error) { } finally {
            this.loading = true
        }
        this.getGroups()
    },
    methods: {
        ...mapActions(['get']),
        async getGroups() {
            this.loading = false
            try {
                const { list } = await this.get(`/account-group`)
                this.groups = list
                this.loading = true
            } catch (error) {
                this.loading = true
            } finally {
                this.loading = true
            }
        },
        async getTasks() {
            const { list, start_date, end_date, filter_group } = await this.get(
                `/tasks-hours-month?team_session=${this.team_session}&order=${this.order_select}&account_id=${this.account_session}&group=${this.filter.group}`
            )
            this.tasks = list
            this.start_date = start_date
            this.end_date = end_date
            if(filter_group) {
                this.filter.group = filter_group
            }
            this.sumHoursTotal()
        },
        sumHoursTotal(){
            var total_hours = 0;
            var total_hours_used = 0;

            this.tasks.forEach(element => {
                total_hours += (element.hours);
                total_hours_used += parseFloat(element.hours_used.replace(",", "."));
            });

            this.total_hours = total_hours
            this.total_hours_used = total_hours_used
        },
        async changeOrder(event) {
            this.loading = false
            this.order_select = event.target.value;
             try {
                await this.getTasks()
            } catch (error) { } finally {
                this.loading = true
            }
        },
        async changeGroup(event) {
            this.loading = false
            this.filter.group = event.target.value;
             try {
                await this.getTasks()
            } catch (error) { } finally {
                this.loading = true
            }
        }
    },
    components: {
        appLoading: Loading,
        appIcon: Icon,
    },
}
</script>



// WEBPACK FOOTER //
// TaskHoursMonth.vue?3a502432